import { propertyUrlSearch } from '@propertypal/shared/src/reducers/properties';
import Head from 'next/head';
import { GetServerSideProps } from 'next/types';
import React, { FunctionComponent } from 'react';
import CoOwnershipNewHomes from '../components/co-ownership/CoOwnershipNewHomes';
import generateMetaTags from '../components/layout/MetaTags';
import IMAGE_LOCATOR from '../constants/imageLocator';
import { requireAuthToken } from '../utils/auth';

const metaData = {
  title: 'Co-Ownership',
  description: '',
  url: `/co-ownership`,
};

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const url = encodeURI('/search?coownOnly=true&sta=forSale&st=sale&pt=residential&currency=GBP&term=3');
  await store.dispatch(propertyUrlSearch(IMAGE_LOCATOR, url, ctx));

  return {
    props: {},
  };
});

const CoOwnership: FunctionComponent = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <CoOwnershipNewHomes />
    </>
  );
};

export default CoOwnership;
